import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { Building2 } from "lucide-react";
import { CompanyUserData } from "../../types/companyUsers.type";
import { formatDateTime } from "@/common/utils/formatters";

type LastConsumptionDetailsProps = {
  lastConsumption: CompanyUserData['last_consumption'];
};

const LastConsumptionDetails = ({ lastConsumption }: LastConsumptionDetailsProps) => {
  return (
    <div className="flex gap-2 items-center">
      <ImageWithPlaceholder
        alt={lastConsumption?.establishment_branch?.general_information?.fantasy_name}
        url={lastConsumption?.establishment_branch?.general_information?.company_logo?.url}
        placeholderIcon={Building2}
        className="size-6"
        iconClassName="size-4"
      />
      <div className="flex flex-col">
        <p className="text-sm font-normal">{lastConsumption?.establishment_branch?.general_information?.fantasy_name}</p>

        {lastConsumption?.created_at && (
          <p className="text-sm font-light italic">{formatDateTime(new Date(lastConsumption?.created_at || 0))}</p>
        )}
      </div>
    </div>
  );
};

export default LastConsumptionDetails;